// extracted by mini-css-extract-plugin
export var productImage = "_lb-1";
export var viewLink = "_lb-2";
export var wishlistItem = "_lb-0";